// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPageComponent-module-root","radioGroup":"PrivacyPageComponent-module-radioGroup","legend":"PrivacyPageComponent-module-legend"};